import ShareIcon from '@mui/icons-material/Share';
import { Alert, Button, ButtonProps, Snackbar } from '@mui/material';
import { duration } from 'dayjs';
import { FunctionComponent, PropsWithChildren, useState } from 'react';
import { withErrorAlerts } from '../../data/Errors';
import { QuestionConfig, QuestionSetConfig } from '../../types/GameplayTypes';
import { copyShareUrlToClipboard, questionSetShareUrl, questionShareUrl } from '../../util/Sharing';

type Props = PropsWithChildren<Omit<ButtonProps, 'onClick'> & {
	url: string;
}>;

/** Low-prominence button used to copy a shareable admin URL. */
export const ShareUrlButton: FunctionComponent<Props> = (props) => {
	const [showConfirmation, setShowConfirmation] = useState(false);

	async function copyUrl() {
		await withErrorAlerts('Failed to copy share link', async function () {
			await copyShareUrlToClipboard(props.url);
			setShowConfirmation(true);
		});
	}

	return <>
		<Button size='small' startIcon={<ShareIcon />}
			onClick={() => void copyUrl()}
			{...props}>
			{props.children ?? 'Share'}
		</Button>
		<Snackbar open={showConfirmation} onClose={() => setShowConfirmation(false)}
			autoHideDuration={duration(6, 'seconds').asMilliseconds()}
			anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
			<Alert>Link copied to clipboard</Alert>
		</Snackbar>
	</>;
};

type ShareQuestionProps = {
	question: QuestionConfig;
};

export const ShareQuestionButton: FunctionComponent<ShareQuestionProps> = (props) => {
	return <ShareUrlButton url={questionShareUrl(props.question.id)} />;
};

type ShareQuestionSetProps = {
	questionSet: QuestionSetConfig;
};

export const ShareQuestionSetButton: FunctionComponent<ShareQuestionSetProps> = (props) => {
	return <ShareUrlButton url={questionSetShareUrl(props.questionSet.id)} />;
};